import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useIsSmartPagePrivacyPolicyEnabled, useSiteConfig, useClientContext } from '@bingads-webui-campaign-react/smart-page-context';
import { proxyReadPrivacyPolicyComponentConfig } from '@bingads-webui-campaign-react/smart-component-privacy-policy';
import { proxyReadBusinessName } from '@bingads-webui-campaign-react/smart-component-header';

import { SmartFooterView } from './smart-footer-view';

export const SmartFooterConnector = ({
  id,
  rootId,
  disabled,
  isMobileEditor,
  isEditMode,
}) => {
  const i18n = useContext(I18nContext);
  const { siteConfig } = useSiteConfig();
  const { isMobile, isRuntime } = useClientContext();

  const isSmartPagePrivacyPolicyEnabled = useIsSmartPagePrivacyPolicyEnabled();
  const {
    policyContent,
    isPrivacyStatementReviewed,
  } = proxyReadPrivacyPolicyComponentConfig(siteConfig, i18n);
  const { businessName, defaultBusinessName } = proxyReadBusinessName(siteConfig, i18n);

  /**
   * Show privacy policy
   * 1. if pilot is on and not in runtime page
   * 2. if pilot is on and in runtime page but the policy has been reviewed
   * for #2, this could make sure old published page won't show the policy when pilot is on
   */
  const showPrivacyPolicy = isSmartPagePrivacyPolicyEnabled && (
    (isRuntime && isPrivacyStatementReviewed) || !isRuntime
  );

  return (
    <SmartFooterView
      i18n={i18n}
      id={id}
      rootId={rootId}
      disabled={disabled}
      hideFooterButton={isMobileEditor}
      showPrivacyPolicy={showPrivacyPolicy}
      isEditMode={isEditMode}
      policyContent={policyContent}
      businessName={businessName || defaultBusinessName}
      isMobile={isMobile}
    />
  );
};

SmartFooterConnector.propTypes = {
  id: PropTypes.string.isRequired,
  rootId: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  isMobileEditor: PropTypes.bool,
  isEditMode: PropTypes.bool,
};

SmartFooterConnector.defaultProps = {
  disabled: false,
  isMobileEditor: false,
  isEditMode: false,
};
